const POST = 'wpis'
const TAGS = 'tagi'
const DATE = 'data'
const CATEGORY = 'kategoria'

const BASE_ROUTE = '/informacje-motoryzacja'

const TAG_WISE_ROUTE = `${BASE_ROUTE}/${TAGS}/:tags`
const DATE_WISE_ROUTE = `${BASE_ROUTE}/${DATE}/:year/:month`
const YEAR_WISE_ROUTE = `${BASE_ROUTE}/${DATE}/:year`
const CATEGORY_WISE_ROUTE = `${BASE_ROUTE}/${CATEGORY}/:category`

const CATEGORY_TAG_WISE_ROUTE = `${BASE_ROUTE}/${CATEGORY}/:category/${TAGS}/:tags` //

const NEW_POST_ROUTE = `${BASE_ROUTE}/${POST}/:slug`
const POST_ROUTE = `${CATEGORY_WISE_ROUTE}/${POST}/:slug`

export {
    BASE_ROUTE,

    TAG_WISE_ROUTE,
    DATE_WISE_ROUTE,
    YEAR_WISE_ROUTE,
    CATEGORY_WISE_ROUTE,
    CATEGORY_TAG_WISE_ROUTE,

    POST_ROUTE,
    NEW_POST_ROUTE,
}